<script>
  import Map from './Map.svelte';
  import { textInfo } from './stores.js';
  import Footer from "./Footer.svelte";

</script>
  <svelte:head>
    <link href='https://fonts.googleapis.com/css?family=Caveat' rel='stylesheet'>

</svelte:head>

<div class = "container">
    <Map />

<!--  <pre id='info'></pre> -->

<!--     <div class='map-overlay-outer'> -->
        <div class='map-overlay'>
            <div class='map-overlay-inner'>

                <div class ='spacing'>
                        <h3>Ship Type</h3>
                        <ul>
                            <li><div class = "square" id ='passenger' ></div> <div>Passenger Vessel</div></li>
                            <li><div class = "square" id ='fishing' ></div>Fishing Vessel</li>
                            <li><div class = "square" id ='sailing' ></div>Sailing Vessel</li>
                            <li><div class = "square" id ='cargo' ></div>Cargo</li>
                            <li><div class = "square" id ='other' ></div>other</li>
                        </ul>


                </div>
                <div class ='spacing'>
                        <h3>Vessel Info</h3>
                        <div id="allinfo">
                            <ul>
                                <li>Name: {$textInfo.name} </li>
                                 <li>Ship Type: {$textInfo.ship_type} </li>
                                 <li>Navigational Status: {$textInfo.navigational_status} </li>
                                 <li>Speed: {$textInfo.speed} </li>
                                 <li>Heading: {$textInfo.heading} </li>

                            </ul>
                        </div>


                </div>
                  <div class ='spacing'>

                        <h3 id="cbd"><img  src="images/cbdata1.png" alt="coffee mug with bagel on it and word Data attached">
                        <a href="#/">CoffeeBagelData</a></h3>



                </div>


            </div>

        </div>

</div>

<style>
    a{color:white;}
    h3{
        color:white;}

.container{
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  height: 100vh;
}


.map-overlay {

  position: absolute;
  width: 280px;
  top: 0;
  left: 10px;
  padding: 10px;
  z-index: 1;
  font: 15px arial, sans-serif;


}

.map-overlay .map-overlay-inner {
  background: rgba(10, 10, 10, 0.5);
  color: #fff;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.10);
  border-radius: 3px;
  padding: 10px;
  margin-bottom: 10px;
  z-index: 1;

}

@media (max-width: 900px) {
.map-overlay .map-overlay-inner{

    height: 200px;
    overflow-y: scroll;
    }
}

.spacing{
  margin:5px;
}

#cbd{

    font-family: 'Caveat';
    background-color: #4D4E4F;
    }
img{height:40px;}

#allinfo{
    height: 200px;
    /*width: 200px;*/
}


    ul{
    list-style: none;
    display: flex;
    flex-direction:column;
    padding:unset;
}
li{display: flex;
flex-direction: row; padding: 5px}

.square{width: 20px; height: 20px;
margin-right: 5px}

/*for toggle layers*/
#passenger{background-color: #01ff45}
#fishing{background-color: #ff013d}
#sailing{background-color: white}
#cargo{background-color: #df00fe}
#other{background-color: #f7ff00}
</style>

